import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Box, Typography } from '@mui/material';
import React from 'react';
import { formatMoney } from './toSaveRows';
import useMeterDetailsStyles from './styles';

// Saved Base and Usage cells show residency shares; the raw fields can repeat a whole meter's charges.
// Sum the same shares as the cells, while Total always sums the actual allocation charges.
export const MeterTotals = _ref => {
  let rows = _ref.rows,
    _ref$shares = _ref.shares,
    shares = _ref$shares === void 0 ? new Map() : _ref$shares,
    _ref$bill = _ref.bill,
    bill = _ref$bill === void 0 ? {} : _ref$bill,
    _ref$isUpload = _ref.isUpload,
    isUpload = _ref$isUpload === void 0 ? false : _ref$isUpload,
    _ref$ownerCents = _ref.ownerCents,
    ownerCents = _ref$ownerCents === void 0 ? 0 : _ref$ownerCents;
  const classes = useMeterDetailsStyles();
  // Parse the formatted cents so totals round exactly as the money cells do, including 10.075.
  const sumMoney = field => isUpload ? 'Calculated when saved' : formatMoney(rows.reduce((sum, row) => {
    var _shares$get$field, _shares$get;
    return sum + Number(formatMoney((_shares$get$field = (_shares$get = shares.get(row.id)) === null || _shares$get === void 0 ? void 0 : _shares$get[field]) !== null && _shares$get$field !== void 0 ? _shares$get$field : row[field]).replace(/[$,.]/g, ''));
  }, 0) / 100);
  const comparison = (value, formatter) => formatter(value) === '' ? 'Not set' : formatter(value);
  const totals = [['Base charge total', sumMoney('baseCharge'), comparison(bill.baseChargeAmount, formatMoney)], ['Usage charge total', sumMoney('usageCharge'), comparison(bill.consumptionCharges, formatMoney)], ['Total charge', sumMoney('allocationCharge'), comparison(bill.amount, formatMoney)]];
  return /*#__PURE__*/React.createElement(Box, {
    component: "section",
    "aria-label": "Meter totals",
    className: classes.meterTotals
  }, totals.map(_ref2 => {
    let _ref3 = _slicedToArray(_ref2, 3),
      label = _ref3[0],
      total = _ref3[1],
      billTotal = _ref3[2];
    return /*#__PURE__*/React.createElement(Box, {
      key: label,
      "aria-label": label
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      sx: {
        fontWeight: 600
      }
    }, label), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "".concat(total, " vs bill ").concat(billTotal)));
  }), !isUpload && ownerCents > 0 && /*#__PURE__*/React.createElement(Box, {
    "aria-label": "Owner (days not on this table)"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      fontWeight: 600
    }
  }, "Owner (days not on this table)"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, formatMoney(ownerCents / 100))));
};